import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiV6Service} from '@service/apiv6.service';
import {TreeService} from '@service/tree.service';
import {forkJoin, lastValueFrom} from 'rxjs';
import {map} from 'rxjs/operators';
import {Tools} from '@service/tools';
import {Router} from '@angular/router';
import {formatDateInt, getComputedDate, prepareDate, verifyPeriod} from '@core/_utils/date.utils';
import {MenuServiceInt} from '@core/_services/menu.serviceint';
import {ConfirmationService} from 'primeng/api';
import {TreeNode} from 'primeng/api';
import {DisplayResultComponent} from '@documalis/displayresult';
import {ConditionFullText, filterFormaList, KeyDetailDocks} from '@documalis/_const/const';
import {DayMonth} from '@documalis/_const/const';
import {MessagesService} from '@core/_services/messages.service';
import {doc_name, doc_creationdate, doc_path, doc_size, reqWds} from '@documalis/_const/const';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import {CheckTools} from '@service/check.tools';
import {ParamUrlService} from '@service/paramurl.service';

import {
    setinfoList,
    returnEmpty,
    encodeUtf8,
    setCurrentRequest,
    getlistColumns,
    setResulProperty,
    currentRequest,
    setResult,
    getInternalPrefUsr, verifyParamsRequest, deleteList, setFormatList, formatUserList, formatResult,
    findItem,
} from '@core/_utils/tools.utils';
import {CommonService} from '@service/common.service';
import {LayoutService} from '../../layout/service/app.layout.service';
import {TranslateService} from '@ngx-translate/core';
import {ItemConfirmComponent} from "../_components/item-confirm/item-confirm.component";

export interface RequestSearch {
    Search: {
        Value;
        Operator;
    };
}

@Component({
    selector: 'app-fulltextsearch',
    templateUrl: './fulltextsearch.component.html',
    styleUrls: ['./fulltextsearch.component.scss'],
    providers: [AutofocusDirective],
})
export class FulltextsearchComponent implements OnInit {


    public stateOptions: any[];

    public srchMode = reqWds;
    public firstDayOfWeek: number;
    public requests = [];

    public keyword = '';
    public keyword1 = '';
    public keyword2 = '';
    public keyword3 = '';
    public condition1 = 0;
    public condition2 = 0;
    public condition3 = 0;
    public formatType = '';
    public ConditionFullText1: any[];
    public ConditionFullText2: any[];
    public ConditionFullText3: any[];
    public formatList: any[];
    public resultRequest: any;
    public resultDisplay: any;
    public resultList: any[];
    public curPage: number;
    public nbDoc: number;
    public index: number;
    public listColumns: any[];
    public displayCriteria = false;
    public displayListResult = false;
    public checkDateBegin = false;
    public checkDateEnd = false;
    public checkFilter = false;
    public dateBegin: Date;
    public dateEnd: Date;
    public isExpanded = false;
    public currentRequest: currentRequest;
    public treeIndex;
    public resultTree;
    public updatePath = '';
    public testPath = '';
    public searchPath = '';
    public selectedFile: TreeNode;//[] = [];
    private rootPath: {
        root: string;
        path: string;
    };

    public listColumnsRequest = [];

    public infoList: any[];
    public isDesktop: boolean = false;
    public displayHelp = false;
    public fetchParam: any;
    private internalPrefUsr: any;
    public loadTree = false;
    public errorMessage = '';
    public errorLoaderDialog = false;
    public blockedTree: boolean = false;


    public displayUpdate = false;
    public labelRequest = '';
    public currentId = 0;
    public currentLabel = '';
    public itemConfirm: ItemConfirmComponent;

    @ViewChild('dispresult') public dispResult: DisplayResultComponent;

    public visibleCount: boolean = false;
    public nbDocCount: number = 0;

    constructor(
        private api: ApiV6Service,
        private _router: Router,
        private tools: Tools,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        public confirmationService: ConfirmationService,
        private treeService: TreeService,
        private checkTools: CheckTools,
        private paramUrlService: ParamUrlService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.ConditionFullText1 = [];
        this.ConditionFullText2 = [];
        this.ConditionFullText3 = [];
        this.formatList = [];
        this.setResultList();
        this.infoList = [];
        this.infoList = setinfoList(this.resultList);
        this.setCondition();
        this.fetchParam = {page: 1, displayNext: false};
        this.internalPrefUsr = getInternalPrefUsr();
        this.stateOptions = [{label: this.translate.instant('ET'), value: 0}, {label: this.translate.instant('OU'), value: 1}];
    }

    ngOnInit() {
        this.firstDayOfWeek = DayMonth.firstDayOfWeek;
        this.index = 0;
        this.listColumnsRequest = [
            {header: this.translate.instant('Name'), field: 'label'},
            {header: this.translate.instant('KeyWord'), field: 'wordsearch0'},
        ];
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.condition1 = 0;
        this.condition2 = 0;
        this.condition3 = 0;
        // this.dateBegin = new Date();
        this.rootPath = this.treeService.initRootPath();
        this.isExpanded = false;
        this.setDate(this.internalPrefUsr.defaultFullTextDate);
        this.getRequestList();
        this.commonService.checkReset();
    }

    public ngOnDestroy() {
        this.fetchParam = null;
    }

    private setDate(aTextDate) {
        if (aTextDate === 'TNoDate') {
            return;
        }
        this.checkDateBegin = true;
        if (aTextDate === 'TInDate') {
            this.dateBegin = getComputedDate('TNow');
        } else {
            this.dateBegin = getComputedDate(aTextDate);
        }
    }

    private async getRequestList() {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.readAll());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.requests = wRes.getRequestList.data.map((item) => {
            item.wordsearch0 = returnEmpty(item.wordsearch0);
            item.wordsearch1 = returnEmpty(item.wordsearch1);
            item.wordsearch2 = returnEmpty(item.wordsearch2);
            item.wordsearch3 = returnEmpty(item.wordsearch3);
            item.wordcond0 = this.setConditionValue(item.wordcond0);
            item.wordcond1 = this.setConditionValue(item.wordcond1);
            item.wordcond2 = this.setConditionValue(item.wordcond2);
            item.searchPath = returnEmpty(item.searchpath);
            item.formatType = returnEmpty(item.formattype);
            return item;
        });
        this.formatList = setFormatList(filterFormaList);
        this.tools.setDocks(KeyDetailDocks, wRes.getDocks, '');
        if (this.paramUrlService.fulltxt === true) {
            this.menu.updateRestrited(this.paramUrlService.restricted);
            await this.execAuto();
        }
    }

    private setConditionValue(aData) {
        if (aData === null) {
            return 0;
        } else {
            return aData;
        }
    }

    private readAll() {
        return forkJoin([
            this.api.execUrlAction('getfulltextrequestbyuser', ''),
            this.api.execUrlAction('getdocksbasket',{name: KeyDetailDocks}),
        ]).pipe(
            map(([getRequestList, getDocks]) => {
                return {getRequestList, getDocks};
            })
        );
    }

    public selectRequest($event) {
        this.setDataRequest($event);
    }

    public nodeSelect(event) {
        this.searchPath = this.treeService.getPathClick(event.node, '');
        this.updatePath = this.searchPath;
        this.searchPath = encodeUtf8(this.searchPath);
        this.rootPath = this.treeService.getRootPath(this.updatePath);
        this.testPath = '';
        this.isExpanded = true;
        this.checkFilter = true;
    }

    public async nodeExpand(event) {
        let wRes;
        wRes = await this.treeService.nodeExpand(event, (callBack) => {
            this.blockedTree = callBack;
        });
    }

    private async setDataRequest(aData) {
        let wRootPath: any = {}
        this.initDataRequest();
        this.keyword = aData.wordsearch0;
        this.keyword1 = aData.wordsearch1;
        this.keyword2 = aData.wordsearch2;
        this.keyword3 = aData.wordsearch3;
        this.condition1 = aData.wordcond0;
        this.condition2 = aData.wordcond1;
        this.condition3 = aData.wordcond2;
        if (aData.datebegin !== null) {
            this.dateBegin = new Date(aData.datebegin);
            this.checkDateBegin = true;
        }
        if (aData.dateend !== null) {
            this.dateEnd = new Date(aData.dateend);
            this.checkDateEnd = true;
        }
        if (aData.searchPath !== '') {
            if (this.loadTree === false) {
                await this.getLoadTree();
            }
            this.checkFilter = true;
            this.rootPath = this.treeService.getRootPath(aData.searchPath);
            this.treeService.openPath = aData.searchPath.trim();
            if (this.treeService.openPath.length !== 0) {
                this.testPath = this.treeService.openPath;
                this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
                this.isExpanded = true;
                this.searchPath = this.treeService.updateSearchPath();
                this.updatePath = this.searchPath;
                wRootPath = this.treeService.getRootPath(this.searchPath);
                if (this.treeService.rootIsPresent(wRootPath.root, this.treeIndex) === false) {
                    this._messageService.addErrorNoStick(this.translate.instant('No_TreeExist'));
                    return;
                }
                await this.treeService.loadRoot(wRootPath.root, this.treeIndex, (callBack) => {
                    this.blockedTree = callBack;
                });
                if (this.treeService.loadRootFailed === false) {
                    this.treeIndex = this.treeService.initTree(this.treeIndex);
                    this.treeIndex = this.treeService.updateFromPath(this.treeIndex);
                    this.selectedFile = this.treeService.lastNode;
                }
            }
        } else {
            this.collapseAll();
        }
        this.formatType = aData.formatType;
    }

    private initDataRequest() {
        this.keyword = '';
        this.keyword1 = '';
        this.keyword2 = '';
        this.keyword3 = '';
        this.condition1 = 0;
        this.condition2 = 0;
        this.condition3 = 0;
        this.dateBegin = undefined;
        this.dateEnd = undefined;
        this.checkFilter = false;
        this.rootPath = this.treeService.initRootPath();
        this.searchPath = '';
        this.formatType = '';
    }

    public onCountDoc($event: any) {
        this.visibleCount = false;
        this.nbDocCount = 0;
        if ($event === 'execute') {
            this.onSearch();
        }
    }

    public async onCount() {
        let wRes: any;
        const wParams = this.initSearch(true);
        if (wParams.paramsOk === false) {
            return;
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('fulltextbis', wParams.request));
            this.checkTools.checkError(wRes);
            if (this.checkTools.getRes() === true) {
                if (wRes.DocCount === undefined || wRes.DocCount === null) {
                    this._messageService.addErrorMsg(this.translate.instant('Err_Doc_Num'));
                } else {
                    this.visibleCount = true;
                    this.nbDocCount = wRes.DocCount;
                }
            } else {
                this._messageService.addErrorMsg(this.checkTools.getMsg());
            }

        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    public async onSearch() {
        let wRes: any;
        let wCheck: any;
        const wParams = this.initSearch(false);
        if (wParams.paramsOk === false) {
            return;
        }
        this.currentRequest = setCurrentRequest(reqWds, wParams.request);
        this.listColumns = getlistColumns(this.resultList, this.translate);
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('fulltextbis', wParams.request));
            wCheck = this.tools.checkResult(wRes, reqWds, this.translate.instant('Find_0'));
            if (wCheck.success === false) {
                return;
            }
            if (wCheck.nbDoc === '0' || wCheck.nbDoc === 0) {
                this.visibleCount = true;
                this.nbDocCount = wRes.DocCount;
                return;
            }
            this.resultRequest = wCheck.resultRequest;
            this.resultDisplay = this.tools.formatDisplayDate(wCheck.resultDisplay, this.listColumns);
            this.curPage = wCheck.curPage;
            this.nbDoc = wCheck.nbDoc;
            this.index = wCheck.index;
            this.displayCriteria = wCheck.displayCriteria;
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private async execAuto() {
        let wSearchPath = '';
        let wData: any;
        if (this.paramUrlService.root !== '') {
            wSearchPath = this.paramUrlService.root + this.paramUrlService.path;
        }
        wData = {
            wordsearch0: this.paramUrlService.text1,
            wordsearch1: this.paramUrlService.text2,
            wordsearch2: this.paramUrlService.text3,
            wordsearch3: this.paramUrlService.text4,
            wordcond0: this.paramUrlService.wordcond0 === null ? 0 : this.paramUrlService.wordcond0,
            wordcond1: this.paramUrlService.wordcond1 === null ? 0 : this.paramUrlService.wordcond1,
            wordcond2: this.paramUrlService.wordcond2 === null ? 0 : this.paramUrlService.wordcond2,
            datebegin: this.paramUrlService.datebegin === '' ? null : this.paramUrlService.datebegin,
            dateend: this.paramUrlService.dateend === '' ? null : this.paramUrlService.dateend,
            searchPath: wSearchPath,
            formatType: this.paramUrlService.formatType
        };
        await this.setDataRequest(wData);
        await this.onSearch();
        this.paramUrlService.clear();
    }

    private initSearch(aCount) {
        let wSearch = {
            paramsOk: false,
            request: {},
        };
        if (this.verifyParams() === true) {
            this.init();
            wSearch.paramsOk = true;
            wSearch.request = this.formatRequestFullText(
                this.rootPath.root,
                this.rootPath.path,
                prepareDate(this.dateBegin, false),
                prepareDate(this.dateEnd, true),
                this.prepareRequest(),
                null,
                this.resultList,
                aCount,
                this.formatType
            );
        }
        return wSearch;
    }

    private prepareRequest() {
        let wRequest = new Array();
        wRequest = this.addItemRequest(wRequest, this.keyword, this.condition1);
        wRequest = this.addItemRequest(wRequest, this.keyword1, this.condition2);
        wRequest = this.addItemRequest(wRequest, this.keyword2, this.condition3);
        wRequest = this.addItemRequest(wRequest, this.keyword3, '');
        return wRequest;
    }

    private addItemRequest(aRequest, aKeyWord, aCond) {
        let wRequestItem: any;
        let wkeyword: string;
        if (aKeyWord !== '') {
            wkeyword = encodeUtf8(aKeyWord);
            wRequestItem = {value: wkeyword, operator: aCond};
            aRequest.push(wRequestItem);
        }
        return aRequest;
    }

    private verifyParams() {
        let wRes = true;
        if (this.keyword.trim() === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Field_Req'));
            wRes = false;
        }
        if (verifyPeriod(this.dateBegin, this.dateEnd) === false) {
            this._messageService.addWarnNoStick(this.translate.instant('Date_KO'));
            wRes = false;
        }
        if (this.checkFilter && this.searchPath === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Path_Fil'));
            wRes = false;
        }
        return wRes;
    }

    public async onChangeCkFilter($event) {
        if (this.loadTree === false) {
            await this.getLoadTree();
        }
        if (!$event.checked) {
            this.rootPath = this.treeService.initRootPath();
        } else {
            this.rootPath = this.treeService.getRootPath(this.updatePath);
        }
    }

    private async getLoadTree() {
        let wRes: any;
        wRes = await this.treeService.getLoadTree();
        if (this.treeService.requestFailed === true) {
            return;
        }
        this.resultTree = wRes.base.result;
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        this.loadTree = true;
    }

    private collapseAll() {
        if (this.isExpanded) {
            this.treeIndex.forEach((node) => {
                this.treeService.expandRecursive(node, false);
            });
        }
        this.isExpanded = false;
    }

    public returnCriteria() {
        this.index = 0;
        this.displayCriteria = false;
        this.displayListResult = false;
    }

    public returnList() {
        this.displayListResult = false;
        this.dispResult.goResultDoc();
    }

    public onReturnResult(event) {
        this.displayListResult = true;
    }

    public onAction(event) {
        if (event === 'move') {
            this.returnList();
        }
    }

    public onNextDocs() {
    }

    private init() {
        this.resultDisplay = null;
        this.listColumns = null;
        this.nbDoc = 0;
    }

    private setCondition() {
        for (let i = 0; i < ConditionFullText.length; i++) {
            this.ConditionFullText1.push({label: this.translate.instant(ConditionFullText[i].label), value: ConditionFullText[i].value});
            this.ConditionFullText2.push({label: this.translate.instant(ConditionFullText[i].label), value: ConditionFullText[i].value});
            this.ConditionFullText3.push({label: this.translate.instant(ConditionFullText[i].label), value: ConditionFullText[i].value});
        }
    }

    private setResultList() {
        this.resultList = [];
        setResult(this.resultList, doc_name, this.translate);
        setResult(this.resultList, doc_creationdate, this.translate);
        setResult(this.resultList, doc_size, this.translate);
        setResult(this.resultList, doc_path, this.translate);
        setResulProperty(this.resultList, doc_name.name, 'thumbinfo', 1);
    }

    private formatRequestFullText(
        Root,
        Path,
        aBeginDate,
        aEndDate,
        aKeyList,
        aVariableList,
        aResultList,
        aCount,
        aFormat
    ) {
        let wCriteria = this.formatCriteriaWds(aKeyList);
        let wResult = formatResult(aResultList);
        let wBeginDate = this.formatDateWds('BeginDate', aBeginDate);
        let wEndDate = this.formatDateWds('EndDate', aEndDate);
        let wRoot = encodeUtf8(Root);
        let wPath = encodeUtf8(Path);
        let wRequest = {
            CountDoc: aCount,
            Wds: {
                WdsData: true,
                Root: wRoot,
                Path: wPath,
                ...wBeginDate,
                ...wEndDate,
                SearchList: wCriteria,
                ResultList: wResult,
                Format: aFormat,
                DoRequest: false,
            },
        };
        return wRequest;
    }

    private formatDateWds(aDateKey, aDate: string) {
        let wDate = '';
        if (aDate.trim() !== '') {
            wDate = aDate;
            return {[aDateKey]: wDate};
        } else {
            return {};
        }
    }

    private formatCriteriaWds(aKeyList) {
        let wRequest = new Array();
        let wRequestItem: RequestSearch;
        aKeyList.forEach((item) => {
            wRequestItem = {Search: {Value: item.value, Operator: item.operator}};
            wRequest.push(wRequestItem);
        });
        return wRequest;
    }

    public closeDia(event) {
        this.displayUpdate = false;
    }

    public async validRequest() {
        let wRes: any = {};
        if (
            verifyParamsRequest(
                this.labelRequest,
                this.currentLabel,
                this.currentId,
                this.requests,
                this._messageService,
                this.translate
            ) === false
        ) {
            return;
        }
        // id de la requête forcé à 0 : création
        if (this.labelRequest !== this.currentLabel) {
            this.currentId = 0;
        }
        const wdata = {
            entete: this.prepareRequestData()
        }
        try {            
            wRes.data = await lastValueFrom(this.api.execUrlAction('updatefulltext', wdata));
            this.requests = [...this.updateListRequest(this.requests, wRes.data)];
            this.currentId = wRes.data.id;
            this.currentLabel = wRes.data.label;
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.displayUpdate = false;
    }

    private prepareRequestData() {
        const requestData = {
            id: this.currentId,
            datebegin: this.getDate(this.dateBegin),
            dateend: this.getDate(this.dateEnd),
            description: null,
            idResult: null,
            label: this.labelRequest,
            visibility: null,
            wordcond0: this.condition1,
            wordcond1: this.condition2,
            wordcond2: this.condition3,
            wordsearch0: this.keyword,
            wordsearch1: this.keyword1,
            wordsearch2: this.keyword2,
            wordsearch3: this.keyword3,
            checkFilter: this.checkFilter,
            searchPath: this.getSearchPath(this.checkFilter, this.updatePath),
            formatType: this.formatType,
        };
        return requestData;
    }

    private updateListRequest(aRequest, aData) {
        let wIndex = -1;
        wIndex = findItem(aRequest, aData.id, 'id');
        aData.searchPath = aData.searchPath.replace(/\//g, '\\');
        if (wIndex !== -1) {
            aRequest[wIndex] = aData;
        } else {
            aRequest.push(aData);
        }
        return aRequest;
    }

    private getDate(aDate) {
        if (aDate != null) {
            return formatDateInt(aDate, false);
        } else return null;
    }

    private getSearchPath(aGetFilter, aData) {
        if (aGetFilter) {
            return aData;
        } else return '';
    }

    public addRequest() {
        if (this.verifyKeyWord() === false) {
            return;
        }
        if (this.currentId !== 0) {
            this.labelRequest = this.currentLabel;
        } else {
            this.labelRequest = '';
        }
        this.displayUpdate = true;
    }

    private verifyKeyWord() {
        let wRes = true;
        if (this.keyword.trim() === '') {
            this._messageService.addErrorNoStick(this.translate.instant('Word_Req'));
            wRes = false;
        }
        return wRes;
    }

    public deleteRequest($event, aData) {
        $event.stopPropagation();
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_Del', {label: aData.label}),
            () => {
                this.delete(aData);
            }
        );
    }

    public async delete(aData) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('deletedfulltext', aData.id));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        this.closeDia(null);
        this.currentId = 0;
        this.currentLabel = '';
        this.requests = [...deleteList(this.requests, wRes.data.data)];
        this._messageService.addSuccess(this.translate.instant('Update_OK'));
    }

    public showDetails($event) {
        this.setDataRequest($event.data);
        this.currentId = $event.data.id;
        this.currentLabel = $event.data.label;
        this.selectRequest($event.data);
    }

    public unSelect() {
        this.currentId = 0;
        this.currentLabel = '';
    }

}
